module.exports = __webpack_public_path__ + "static/media/ic-face-yellow-original.88f750fd.svg";